// extracted by mini-css-extract-plugin
export default {"buttonZone":"LandingPage_buttonZone__IgzIF","btnSignIn":"LandingPage_btnSignIn__8jgj0","logo":"LandingPage_logo__IFIeC","contentPage":"LandingPage_contentPage__QGb8N"};